export default {
  common: {
    Name_of_the_part: '部件名称',
    Box_type: '盒型',
    Match_number: '配数',
    Open_the_edition: '开版',
    Move_up: '上移',
    Move_down: '下移',
    Copy_the_part: '复制部件',
    Delete_a_part: '删除部件',
    Length: '长',
    Width: '宽',
    Height: '高',
    Expand: '展开',
    Sealing_direction: '封度方向',
    Paper_length_direction: '纸长方向',
    The_current_version_is_opened_by_the_system: '当前为系统开版',
    Expand_size: '展开尺寸',
    Typographic_size: '排版尺寸',
    Number_of_typesetting: '排版个数',
    Longitudinal: '纵',
    Horizontal: '横',
    Sealed_with_paper: '用纸封度',
    Mounting_pit: '裱坑',
    Edit_the_pitted_paper: '编辑坑纸',
    Packing: '包装',
    Click_to_view_the_drawing: '点击查看图样',
    Open_the_version_manually: '手动开版',
    Product_type: '产品类型',
    Paper_degree_direction: '纸度方向',
    Height_direction: '高度方向',
    Length_direction: '长度方向',
    No_requirements: '无要求',
    Typeset_to_expanded_size: '按展开尺寸排版',
    Paper_size: '用纸尺寸',
    Number_of_opened_papers: '开纸个数',
    Available_sealing_degree: '可用封度',
    Sealing_degree_prompt: '多个封度值用“,”逗号隔开，平张纸格式',
    Typesetting_results: '排版结果',
    Display_all_opening_results: '显示全部开版结果',
    Trial_arrangement: '试排',
    Boarding_size: '上车尺寸',
    Number_of_stones: '石数',
    Sealing_degree: '封度',
    Open_the_paper: '开纸',
    Number_of_open_papers: '开纸数',
    Paper_opening_loss: '开纸损耗',
    Thickness: '厚度',
    Size: '尺寸',
    Product_Type_Required: '产品类型必选',
    Dimension_Type_Required: '尺寸类型必选',
    Please_fill_in_the_dimension_height: '请填写尺寸高度',
    Length_is_required: '长度必填',
    Width_is_required: '宽度必填',
    No_data_available: '暂无数据',
    Please_select_data_on_the_left: '请选择左侧数据',
    Pit: '坑',
    Cost_analysis_data_has_not_yet_been_generated: '成本分析数据尚未生成',
    Refresh: '刷新',
  },
  basicInformation: {
    The_pitted_paper_you_choose_is_special_paper_and_the_available_sealing_degree_is: '你选择的坑纸面纸是特度纸, 可用封度是',
    Does_not_conform_to_the_opening_size: '与开版尺寸不符合',
    The_format_of_the_seal_information_input_is_not_uniform_and_the_opening_data_cannot_be_obtained: '输入的封度信息格式不统一无法获取开版数据！',
    The_expansion_dimension_is_automatically_calculated_successfully: '展开尺寸自动计算成功',
    If_there_is_any_size_deviation_please_go_to_the_opening_page_to_manually_modify_the_opening: '尺寸有偏差的请到开版页面手动修改开版',
    The_automatic_calculation_of_the_expansion_dimensions_failed: '展开尺寸自动计算失败。可能没有设置相关计算公式！请到开版页面手动开版.',
    Typeset_size_format_entered_is_incorrect: '输入的排版尺寸格式有误',
    The_modified_layout_size_is_out_of_range: '修改排版尺寸超出范围（左右值的修改范围在',
    Within: '以内',
    The_format_of_the_expanded_dimension_entered_is_incorrect: '输入的展开尺寸格式有误',
    Platoon: '排',
    Use_paper: '用纸',
    Loss: '损耗',
    Please_enter_the_expansion_dimension: '请输入展开尺寸',
    Please_enter_the_product_size: '请输入产品尺寸',
    There_is_no_sealing_information_for_the_material: '物料没有封度信息，请到开版页面手动开版！',
  },
  basicInformationwbox: {
    input_format200100: '输入格式:200*100',
    process: '木工工序',
    lots_use: "多个封度值用“,”逗号隔开，平张纸格式（31*43，35*47）",
    useable_fd: '可用封度',
    open_v: "开版",
    open_v_hand: '手动开版',
    pro_type: '产品类型:',
    paper_dre: '纸度方向:',
    H_dre: 'H 高度方向',
    L_dre: 'L 长度方向',
    N_dre: 'N 无要求',
    Nail_opening: '钉口(MM):',
    Socket: '插口(MM):',
    product_size: '产品尺寸',
    expand: '展开:',
    fd_dre: '封度方向:',
    Layout_size: '排版尺寸:',
    use_paper_size: '用纸尺寸:',
    open_paper_sum: '开纸个数',
    useable_sealing_degree: '可用封度（英寸）:',
    layout_result: '排版结果:',
    open_toSee: '显示全部开版结果',
    try_lay: '试排',
    confirm: '确定',
    layout_number: '排版个数',
    upCar_size: '上车尺寸',
    rock_num: '石数',
    sealing_degree: '封度',
    open_paper: '开纸',
    o_p_loss: '开纸损耗',
    painting: '喷漆',
    scrap_paint: '刮后喷漆',
    paint_surface: '油漆面',
    paint_process: '油漆工序',
    scrap_youqi: '刮后油漆',
    yq: '油漆',
    yqm: '油漆面',
    chose: '选择',
    processno: '工序编号',
    processname: '工序名称',
    param: '参数',
    size1: '尺寸1',
    size2: '尺寸2',
    pro_mustchose: '产品类型必选',
    size_type_must_chose: '尺寸类型必选',
    s_m_p: '长度必填',
    w_m_p: '宽度必填',
    paint5: '5面油漆',
    paint6: '6面油漆',
    no_data_now: '暂无数据',
    chose_left: '请选择左侧数据',
    input_size_first: '请先输入尺寸信息',
    com_info: '请完善参数信息',
    fail_p_input_flag_size: '开版失败-请输入平面尺寸信息',
    fail_p_input_woold_info: '开版失败-请选择木料信息',
    counting: '计算排版中',
    butongyi: '输入的封度信息格式不统一无法获取开版数据!',
    layout_format_wrong: '输入的排版尺寸格式有误!',
    outrange1: '修改排版尺寸超出范围（左右值的修改范围在',
    outrange2: 'INCH以内）!',
    expandformwrong: '输入的展开格式有误!',
    check_size: '请检查输入的尺寸信息是否有误!',
    check_format: '输入的尺寸信息格式有误!',
    chose_item: '请选择物料',
    hand_input_p: '物料没有可用封度信息，请手动输入！',
    seal_degree_input: '请输入可用封度信息',
    data_counting: '数据计算中',
    no_fit_data: '没有合适的开版数据,请到开版页面手动开版!',
    no_fit_da: '没有合适的开版数据',
    chose_result: '请选择计算结果',
  },
  materialWindow: {
    Material: '物料',
    Material1: '主料',
    Material_type: '物料类型',
    Please_select_a_material_type: '请选择物料类型',
    Please_select_a_material: '请选择物料',
    Default_item: '默认物料',
    Material_selection: '物料选择',
    Roll_paper: '卷筒纸',
    Pit_cardboard: '坑纸板',
    Other_materials: '其他物料',
    Timber: '木料',
    Consultation: '咨询',
    Blister: '吸塑',
    AcMq: '不干胶(模切)',
    Selected_items: '已选物料',
    Item_attributes: '物料属性',
    Subclass_coding: '小类编码',
    Subclass_name: '小类名称',
    Bigclass_coding: '大类编码',
    Bigclass_name: '大类名称',
    Brand_code: '品牌编码',
    Brand_name: '品牌名称',
    Gram_weight: '克重',
    Classification_code: '分类编码',
    Classification_name: '分类名称',
    Enter_a_Wood_Number_or_Name_Search: '输入木料编号或名称搜索',
    Searching: '搜索中',
    Wood_coding: '木料编码',
    Wood_name: '木料名称',
    Thickness: '厚度',
    Please_select_stock_type: '请选择纸料类型',
    Please_select_a_brand: '请选择品牌',
    Please_select_the_gram_weight: '请选择克重',
    Data_is_being_loaded: '数据加载中',
    Please_select_a_wood_classification: '请选择木料分类',
    Please_select_wood_information: '请选择木料信息',
    Please_select_category_information: '请选择分类信息',
    Please_select_thickness_information: '请选择厚度信息',
    Please_select_the_material_category: '请选择物料大类',
    Please_select_material_sub_category: '请选择物料小类',
    Please_enter_the_requirements_for_bursting_strength_and_edge_compression_strength: '请输入耐破强度和边压强度的要求',
  },
  linkageDropdown: {
    firstVal: '一级联动',
    secondVal: '二级联动',
    thirdVal: '三级联动',
    select: '请选择',
  },
  procedureParameter: {
    isProcedureEnable: '启用工序',
    processType: '工序类别',
    process: '工序',
  },
  materialChoice: {
    item_type: '物料类型',
    chose_item_type: '请选择物料类型',
    paper_type: '纸料类型',
    paper_type_chose: '请选择纸料类型',
    brand: '品牌',
    chose_brand: '请选择品牌',
    k_weight: '克重',
    chose_k_w: '请选择克重',
  },
  procedureChoice: {
    Customize: '自定义',
    Process: '工序',
    Other_processes: '其他工序',
    Assemble: '组装',
    Process_parameters_to_be_selected: '需选择工艺参数',
    Estimated_order_number: '预估单号',
    Operation_selection: '工序选择',
    Type: '类型',
    Please_enter_operation_number_or_name_to_search: '请输入工序编号或名称检索',
    Number: '编号',
    The_material_price_has_been_included_in_the_labor_cost_unit_price_of_this_operation: '此工序工费单价中已包含料价',
    Operation_name: '工序名称',
    Small_process: '小工序',
    Please_select: '请选择',
    Operation_description: '工序说明',
    Ergonomics_estimation: '工效预估',
    Parameter_name: '参数名称',
    Parameter_value: '参数值',
    Area: '面积',
    Select_an_item: '选择物料',
    Edit_the_pitted_paper: '编辑坑纸',
    Part_number: '物料编号',
    Material_name: '物料名称',
    Size_long: '尺寸长',
    Size_wide: '尺寸宽',
    Size_high: '尺寸高',
    Attribute: '属性',
    Operation_selected: '已选工序',
    Pit_paper: '坑纸',
    Pit_plate: '坑板',
    Common_process: '常见工序',
    Please_select_the_operation_to_be_modified: '请选择要修改的工序',
    Failed_to_get_process_parameter: '获取工艺参数时失败',
    Mounting_card_box_automatic_machine_burying: '裱卡盒,自动机埋口',
    Mounting_card_box_automatic_machine_buried_mouth_buckle_bottom: '裱卡盒,自动机埋口+扣底',
    Mounting_card_box_automatic_machine_burying_button_sticking_hanging_head: '裱卡盒,自动机埋扣+粘挂头',
    Single_pit_automatic_machine_buried: '单坑,自动机埋口',
    Double_pit_automatic_machine_buried: '双坑,自动机埋口',
    Mounting_card_box_burying_mouth: '裱卡盒,埋口',
    Single_pit_buried: '单坑,埋口',
    Double_pit_buried: '双坑,埋口',
    Mounting_card_box: '裱卡盒',
    Single_pit: '单坑',
    Double_pit: '双坑',
    Mounting_card_box_semi_automatic_machine_buried_mouth: '裱卡盒,半自动机埋口',
    Single_pit_semi_automatic_machine_buried: '单坑,半自动机埋口',
    Double_pit_semi_automatic_buried_port: '双坑,半自动机埋口',
    Beer_printing_sheet: '啤印张',
    Please_check_the_operation_on_the_left: '请勾选左侧的工序',
    Yes: '是',
    No: '否',
    Efficiency: '效率',
    Number_of_people: '人数',
    Pre_work_efficiency: '预工效',
    You_have_selected_a_manual_operation_An_operation_description_must_be_entered_for_this_operation: '你选择了手工制作工序，此工序必须输入工序说明',
    You_have_selected_a_laser_engraving_operation_for_which_area_information_must_be_entered: '你选择了镭射雕刻工序，此工序必须输入面积信息',
    The_material_price_has_been_included_in_the_labor_cost_unit_price_of_this_operation: '此工序工费单价中已包含料价',
    Please_check_the_operation_on_the_left_first: '请先勾选左侧的工序',
    Please_select_an_operation_first: '请先选选择工序',
    Please_select_pit_paper_on_the_left: '请在左侧选择坑纸',
    Please_select_an_item_on_the_left_to_insert: '请在左侧选择一项插入',
    Please_select_Insert_Target_Row_on_the_right: '请在右侧选择插入目标行',
    This_is_the_first_line_and_cannot_be_moved_up: '已是首行，不能上移',
    Please_select_to_move_up_the_target_row_on_the_right: '请在右侧选择上移目标行',
    This_is_the_last_line_cannot_move_down: '已是末行，不能下移',
    Please_select_Move_Down_Target_Row_on_the_right: '请在右侧选择下移目标行',
    Facial_paper: '面纸',
    Bottom_paper: '底纸',
    Layer: '层',
    Please_select_the_type_of_pit_paper: '请选择坑纸类型',
    Please_select_pit_paper_pit_type: '请选择坑纸坑型',
    No_pit_paper_is_selected: '未选择坑纸',
    The_numb_of_layers_of_that_pit_pap_is_at_least_2: '坑纸层数至少是2层',
    Pit_paper_should_be_even: '坑纸应为偶数',
    The_number_of_layers_of_the_pit_plate_shall_be_at_least_3: '坑板层数至少是3层',
    Pit_plates_shall_be_odd_numbered: '坑板应为奇数',
    This_element_is_already_the_first_element: '此元素已是第一个元素',
    This_element_is_already_the_last_element: '此元素已是最后一个元素',
  },
  processEfficiency: {
    work_pre: '工效预估',
    estimate_no: '预估单号:',
    estimate_rate: '预估效率:',
    estimate_people: '预估人数:',
    to_ie: '致IE工程师:',
    estimate_date: '期望回复期：',
    procedure_desc: '工序说明',
    pro_pre_desc: '工序预估说明',
    add_file: '请添加文件',
    atta_file: '附件',
    file_name: '文件名称',
    op: '操作',
    load_down: '下载',
    not_be_modify: '该工效预估已经有回复信息，无法修改！',
    t0_null: 'TO信息不能为空！',
    expect_null: '期望回复期不能为空！',
    pro_null: '工效预估说明不能为空！',
    keep_ornot: '取消操作将清除之前的工效预估信息, 是否继续?',
    clear: '工效预估清除成功!',
    upload_suc: '上传成功',
    upload_max: '最大文件可以上传10M',
    confirm_del: '确定移除',
  },
  procedureChoiceMaterial: {
    new_item: '新物料',
    category: '分类',
    item_small_type: '物料小类',
    item_code: '物料编号',
    item_name: '物料名称',
    f_degree: '封度',
    it_size: '物料尺寸',
    req: '要求回复期限：',
    spec: '物料规格',
    unit: '用量单位',
    count_way: '计价方式',
    gc: '公差要求',
    pack_re: '包装要求',
    test_re: '测试要求',
    remark_re: '测试要求备注',
    address: '送货地址',
    attach_file: '物料附件',
    item_chose: '物料选择',
    item_type: '物料类型',
    input_item: '请输入料号或料号名称检索',
    search: '检索',
    select: '选择',
    attribute: '属性',
    guige: '规格',
    validity: '有效期',
    modify_item: '修改物料属性',
    set_item: '设定物料',
    purchase_item: '采购过的物料',
    asked_item: '询价过的物料',
    cannot_be_change: '该物料已经有价格信息，无法修改!',
    input_keyword: '请输入关键词',
    select_process: '请先选择工序',
    upload_suc: '上传成功',
    upload_max: '最大文件可以上传10M',
    Are_you_sure_to_remove: '确定移除',
    null_itemname: '物料名称不能为空!',
    null_seal: '请输入正确的封度信息!',
    null_to_dept: '致部门不能为空!',
    null_ddl: '要求回复期限不能为空!',
    null_itemspec: '物料规格不能为空!',
    null_unit: '用量单位不能为空!',
    null_test_request: '测试要求不能为空!',
    null_test_remark: '测试要求备注不能为空!',
    null_errand: '公差要求不能为空!',
    null_pack_re: '包装要求不能为空!',
    null_de_address: '送货地址不能为空!',
    null_count_way: '计价方式不能为空!',
    null_catagory: '分类不能为空!',
    null_small_ca: '物料小类不能为空!',
    try_later: 'LQ表数据修改异常，请稍候在试',
    check_left: '请先勾选左侧的工序',
    chose_one: '只能选择一种开版物料',
    There_is_a_sample: '有样办',
  },
  printColor: {
    Printing_color: '印色',
    Front_printing_color: '正面印色',
    Spot_color_please_go_to_more_to_enter: '专色请到更多里面输入',
    Please_select_over_oil: '请选择过油',
    Underside_printing: '底面印色',
    No_printing_color: '无印色',
    Face_printing_color: '面印刷颜色',
    Primary_Color: '原色',
    Please_select_a_printing_plate: '请选择印版',
    General_and_special: '普通专',
    Plate_printing_machine: '印版机',
    Metal_fluorescent_special: '金属/荧光专',
    White_ink: '白墨',
    Connect_the_machine_for_oil_passing: '连机过油',
    Bottom_print_color: '底印刷颜色',
    Ordinary: '普通',
    Word_version: '字版',
    Earth: '大地',
    Dye_the_paper: '染纸',
    Ordinary_printing: '普通印刷',
    UV_printing: 'UV印刷',
    Printed_on_one_side: '单面印刷',
    Printed_on_both_sides: '双面印刷',
    Failed_to_load_the_online_oiling_data_source: '加载连机过油数据源时失败',
  },
  customerChoice: {
    selectPlaceholder: '请至少输入4个字符',
    validHint: '您没有该客户报价信息的查看权限',
  },
  basicInformationbbkpzz: {
    finish_product: '成品',
    component: '部件',
    ppnum0: 'PP数',
    ppnum: 'PP数/版',
    match_num: '配数',
    paper_re: '纸纹要求',
    direction: '书脊方向',
    vertical: '与书脊垂直',
    no_need: '无要求',
    pull: '拉页',
    same_ver: '同版',
    bs: '版数',
    ms: '模数',
    ex_size: '展开尺寸',
    pro_size: '产品尺寸',
    size_200100: '输入格式:200*100',
    sys_open_v: '系统计算开版',
    pp_per: '每折PP数',
    break_num: '折数',
    open_v: '开版',
    product_type: '产品类型',
    zds: '直度书',
    hds: '横度书',
    link_num: '联本数',
    link_book: '联本',
    no_select: '未选择',
    lay_size: '排版尺寸',
    paper_size: '用纸尺寸',
    open_paper_size: '开纸个数',
    usable_degree: '可用封度（英寸）',
    many_degree: '多个封度值用“,”逗号隔开',
    op_result: '开版结果',
    show_all_v: '显示全部开版结果',
    try_lay: '试排',
    lay_num: '排版个数',
    pucar_size: '上车尺寸',
    paper_d: '纸纹方向',
    rock_num: '石数',
    Paper_degree_direction: '纸度方向',
    Open_according_to_the_expanded_size: '按展开尺寸开版',
    Shell: '皮壳',
    Title_page: '扉页',
    Color_page: '彩页',
    Nevin: '内文',
    Fold: '折',
    Modify_layout_size_out_of_range: '修改排版尺寸超出范围',
    The_modification_range_of_the_left_value_is_in_the: '左边值的修改范围在',
    The_modification_range_of_the_right_value_is_in_the: '右边值的修改范围在',
    Cover_has_the_wrong_expanded_size: '封面的展开尺寸有误',
    input_nevin_size:'请输入内文尺寸',
  },
  materialSelected: {
    Select_a_material: '选择材质',
    See_the_pit: '见坑',
    Cardboard: '纸板',
    All: '所有',
    Facial_paper: '面纸',
    Core_paper: '芯纸',
    Please_enter_the_content: '请输入内容',
    Insert_before_the_selected_row: '插入到选中行的前面',
    Insert: '插入',
    Move_up: '上移',
    Move_down: '下移',
    Intelligent_matching: '智能匹配',
    Leng_type: '楞型',
    Please_select_the_flute_type: '请选择楞型',
    Please_select_pit_paper: '请选择坑纸',
    Selection_of_only_one_layer_is_not_allowed: '不允许仅选一层',
    The_number_of_cardboard_pit_paper_layers_should_be_an_odd_number: '纸板坑纸层数应该是奇数层',
    The_number_of_matching_paper_layers_of_the_pit_paper_should_be_even: '见坑坑纸配纸层数应该是偶数层',
    The_number_of_layers_of_pit_paper_does_not_match_the_corrugation_type: '坑纸层数和楞型不匹配',
    Warm_tips: '温馨提示',
  },
  packingArrange2D: {
    Volume_size: '容积尺寸',
    Available_clear_height: '可用净高',
    Calculation: '计 算',
    Result: '结果',
    Total_number_of_cases: '总箱数',
    Wide_row: '宽排',
    Long_row: '长排',
    Turn_around: '调转方向',
    Plane_loading_rate: '平面装载率',
    Three_dimensional_loading_rate: '立体装载率',
    Swing_high: '摆高',
    Number_of_cartons: '纸箱数',
    Number_of_cards: '卡板数',
    The_total_number_of_boxes_is_too_large_to_draw_the_layout: '总箱数太大排版图无法绘制',
    Calculation_failed: '计算失败',
  },
  baidu: {
    Baidu_ranging: '百度测距',
    Select_an_address: '选择地址',
    Please_enter_an_address_keyword: '请输入地址关键词',
    Current_route_distance: '当前路线距离',
    Ranging: '测 距',
    You_have_not_selected_a_location: '您没有选择位置',
    Please_select_the_starting_point_information_first: '请先选择起点信息',
    The_latitude_and_longitude_information_is_not_set_for_the_starting_point: '起点没有设置经纬度信息',
  },
  quoteReturnRecordList: {
    title: '报价申请退回记录',
    RequestCode: '报价单号',
    CustomerCode: '客户代码',
    CustomerName: '客户名称',
    Deptname: '营业部',
    QuoteCreateUserName: '开单人',
    ReturnReasons: '退回原因',
    ReturnDate: '退回日期',
  }
}



// WEBPACK FOOTER //
// ./src/components/local/zh.js